// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../font/static/Montserrat-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
    font-family: 'MonstserratBlack';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype')
   
}
/* src: url('../font/Montserrat-VariableFont_wght.ttf') format ('truetype');
src: url ('../font/static/Montserrat-ExtraBold.ttf') format('truetype'); */

body {
    background-color: #9E184B;
}

.Autentificacao_page__LqIGG{
    background-color: #9E184B;
    background-size: auto auto;
    width: 100%;
    height: 100%;
    z-index: -1;
}

.Autentificacao_container__a8BgL{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.Autentificacao_page__LqIGG p{
    color: #543A20;

}


.Autentificacao_sect__XGcMA{
    width: 40%;
    min-width: 600px;
    height: 480px;
    background-color: #EBE9E2;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}

.Autentificacao_imagemCafe__3jeB8{
    position: absolute; 
    width: 25%;
    top: 0;
    right: 0;
}

.Autentificacao_tituloYouCoffee__POkWt{
   width: 50%;
   text-align: center;
   
   
}

.Autentificacao_tituloYouCoffee__POkWt h1{
    width: 100%;
    font-size: 55px;
    margin-top: 0;
    margin-bottom: 20px;
    color:#9E184B;
    font-family: 'MonstserratBlack', sans-serif;
}

@media (max-width: 480px) {
    .Autentificacao_imagemCafe__3jeB8{
        width: 0%;
        top: 0;
        right: 0;
    }

    .Autentificacao_imagemTopo__nIuwO{
     align-items: center;   
     margin-left: 16%;
    }
 }

.Autentificacao_imagemLogoYoux__3qU6i{
    width: 9%;
    top: 0;
    left: 0;
    margin-top: 60px;
    margin-left: 70px;
    position: absolute;
}

.Autentificacao_imagemXicara__k\\+rH8{
    position: absolute;
     width: 19%;
    bottom: 0;
    left: 0;
    border-radius: 20%;
}

.Autentificacao_buttonEdit__gXaV0{
    width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.Autentificacao_caixaInput__HU1or{
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

}

.Autentificacao_esqueciSenha__Pd3Uy{
    font-size: 10px;
    width: 50%;
    margin-top: 1px;
    margin-bottom: 30px;
    color: #543A20;
    display: flex;
    justify-content: space-between;
}

.Autentificacao_subTitulo__wDQs\\+{
    font-size: 20px;
    margin-bottom: 6px;
}

.Autentificacao_caixaAllInput__fTBHr{
    width: 50%;
}

.Autentificacao_caixaAllInputSenha__mWbzN{
    width: 67%;
}


`, "",{"version":3,"sources":["webpack://./src/paginas/Autentificacao/Autentificacao.module.css"],"names":[],"mappings":";AACA;IACI,+BAA+B;IAC/B;;AAEJ;AACA;0EAC0E;;AAE1E;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;;AAElB;;;AAGA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,+EAA+E;AACnF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,QAAQ;AACZ;;AAEA;GACG,UAAU;GACV,kBAAkB;;;AAGrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI;QACI,SAAS;QACT,MAAM;QACN,QAAQ;IACZ;;IAEA;KACC,mBAAmB;KACnB,gBAAgB;IACjB;CACH;;AAED;IACI,SAAS;IACT,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;KACjB,UAAU;IACX,SAAS;IACT,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd","sourcesContent":["\n@font-face {\n    font-family: 'MonstserratBlack';\n    src: url('../../font/static/Montserrat-ExtraBold.ttf') format('truetype')\n   \n}\n/* src: url('../font/Montserrat-VariableFont_wght.ttf') format ('truetype');\nsrc: url ('../font/static/Montserrat-ExtraBold.ttf') format('truetype'); */\n\nbody {\n    background-color: #9E184B;\n}\n\n.page{\n    background-color: #9E184B;\n    background-size: auto auto;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n}\n\n.container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n.page p{\n    color: #543A20;\n\n}\n\n\n.sect{\n    width: 40%;\n    min-width: 600px;\n    height: 480px;\n    background-color: #EBE9E2;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;\n}\n\n.imagemCafe{\n    position: absolute; \n    width: 25%;\n    top: 0;\n    right: 0;\n}\n\n.tituloYouCoffee{\n   width: 50%;\n   text-align: center;\n   \n   \n}\n\n.tituloYouCoffee h1{\n    width: 100%;\n    font-size: 55px;\n    margin-top: 0;\n    margin-bottom: 20px;\n    color:#9E184B;\n    font-family: 'MonstserratBlack', sans-serif;\n}\n\n@media (max-width: 480px) {\n    .imagemCafe{\n        width: 0%;\n        top: 0;\n        right: 0;\n    }\n\n    .imagemTopo{\n     align-items: center;   \n     margin-left: 16%;\n    }\n }\n\n.imagemLogoYoux{\n    width: 9%;\n    top: 0;\n    left: 0;\n    margin-top: 60px;\n    margin-left: 70px;\n    position: absolute;\n}\n\n.imagemXicara{\n    position: absolute;\n     width: 19%;\n    bottom: 0;\n    left: 0;\n    border-radius: 20%;\n}\n\n.buttonEdit{\n    width: 50%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.caixaInput{\n    width: 100%;\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n}\n\n.esqueciSenha{\n    font-size: 10px;\n    width: 50%;\n    margin-top: 1px;\n    margin-bottom: 30px;\n    color: #543A20;\n    display: flex;\n    justify-content: space-between;\n}\n\n.subTitulo{\n    font-size: 20px;\n    margin-bottom: 6px;\n}\n\n.caixaAllInput{\n    width: 50%;\n}\n\n.caixaAllInputSenha{\n    width: 67%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Autentificacao_page__LqIGG`,
	"container": `Autentificacao_container__a8BgL`,
	"sect": `Autentificacao_sect__XGcMA`,
	"imagemCafe": `Autentificacao_imagemCafe__3jeB8`,
	"tituloYouCoffee": `Autentificacao_tituloYouCoffee__POkWt`,
	"imagemTopo": `Autentificacao_imagemTopo__nIuwO`,
	"imagemLogoYoux": `Autentificacao_imagemLogoYoux__3qU6i`,
	"imagemXicara": `Autentificacao_imagemXicara__k+rH8`,
	"buttonEdit": `Autentificacao_buttonEdit__gXaV0`,
	"caixaInput": `Autentificacao_caixaInput__HU1or`,
	"esqueciSenha": `Autentificacao_esqueciSenha__Pd3Uy`,
	"subTitulo": `Autentificacao_subTitulo__wDQs+`,
	"caixaAllInput": `Autentificacao_caixaAllInput__fTBHr`,
	"caixaAllInputSenha": `Autentificacao_caixaAllInputSenha__mWbzN`
};
export default ___CSS_LOADER_EXPORT___;
